/* ================================================== */
/* SCROLL OFF
/* ================================================== */

var scrollLocked = true;
$('.scroll-off').each(function(index, element) {
	$(element).on('tap click', function() {
		if (scrollLocked == true) {
			$(this).removeClass('scroll-off');
			scrollLocked = false;
		}
	});
});